import React from "react";
import { HiOutlineShieldCheck } from "react-icons/hi";
import useTranslator from "../../hooks/useTranslator";
import { Button, Modal, Notice } from "../design";
import "./SaveAwardedChangesModal.css";

const SaveAwardedChangesModal = ({
  show,
  onHide,
  onConfirm,
  onContact,
  isLoading,
  hasActiveInsurance,
  hasActiveSkorProtect,
}) => {
  const { _t } = useTranslator();
  const handleHide = () => {
    if (!isLoading) onHide();
  };

  return (
    <Modal
      open={show}
      onClose={handleHide}
      dismissible={false}
      id="save-awarded-changes-modal"
      icon={
        <div className="save-awarded-changes-icon">
          <HiOutlineShieldCheck />
        </div>
      }
      title={
        hasActiveSkorProtect
          ? _t(
              "propertyHasActiveSkorProtectPolicy",
              "This property has an active Skor Protect policy"
            )
          : _t("saveChangesToRentedProperty")
      }
      description={
        hasActiveSkorProtect
          ? _t(
              "changingGuaranteedRentalPolicyMayInvalidateCurrentPolicy",
              "Changing the tenants or the rent on a guaranteed rental policy may invalidate the current policy. You can proceed, and we will contact you to review the next steps, or you can write to us beforehand if you have any questions"
            )
          : _t("aboutToChangeTenantsOnAlreadyRentedProperty")
      }
      actions={
        <>
          <Button
            variant="secondary"
            size="lg"
            onClick={hasActiveSkorProtect ? onContact : handleHide}
            disabled={isLoading}
          >
            {hasActiveSkorProtect ? _t("contact", "Contact") : _t("cancel")}
          </Button>
          <Button size="lg" onClick={onConfirm} loading={isLoading}>
            {isLoading
              ? _t("saving")
              : hasActiveSkorProtect
                ? _t("continueWithAddendum", "Continue with addendum")
                : _t("awardProperty")}
          </Button>
        </>
      }
    >
      {hasActiveInsurance && !hasActiveSkorProtect && (
        <Notice tone="warning" className="save-awarded-insurance-notice">
          <strong>{_t("propertyAlreadyHasActiveNonPaymentInsurance")}</strong>{" "}
          <span>{_t("newTenantsRequireManualInsuranceChecks")}</span>
        </Notice>
      )}
    </Modal>
  );
};

export default SaveAwardedChangesModal;
